module.exports = __webpack_public_path__ + "img/FCHS_ER_2023-1.f12d2ed5.jpg";